import type { BoxProps } from "@chakra-ui/react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

import defaultComponents from "./defaultComponents";
import Wrapper from "./parts/Wrapper";

// Chakra style props are forwarded to the wrapper Box, which is the only way to override
// the `__css` base style (color/size) the Markdown theme sets on it — a parent's color
// cannot cascade past an explicit value on the wrapper itself.
interface Props extends Omit<BoxProps, 'children'> {
  testId?: string;
  children: string | undefined | null;
}

/**
 * For now we only allow to pass styling props to the wrapper (not to the inner components)
 * But it is still possible to change the default styling of each 'part' from
 * the theme > components > Markdown
 */
const Markdown = ({ testId, children, ...props }: Props) => (
  <Wrapper {...props} data-test-id={`b99a408b-${testId}`}>
    <ReactMarkdown components={defaultComponents} rehypePlugins={[rehypeRaw]}>
      {children}
    </ReactMarkdown>
  </Wrapper>
);

export default Markdown;
